export type SupportedCurrency = "USD" | "EUR" | "CDF";

export interface EstablishmentProfile {
  name: string;
  address: string;
  phone: string;
  email: string;
}

export interface PharmacySettings {
  currency: SupportedCurrency;
  invoicePrefix: string;
  /** Exiger un patient enregistré (pas de client ponctuel). */
  requirePatientOnInvoice: boolean;
  /** Bloquer la dispensation tant que le pharmacien n'a pas validé l'ordonnance. */
  requirePharmacistValidation: boolean;
  /** Pousser les factures validées vers itaas-billing. */
  syncBillingOnInvoice: boolean;
  /**
   * Pharmacie autonome : le pharmacien peut créer une ordonnance sans médecin.
   * Désactivé par défaut — activation réservée à l'administrateur.
   */
  allowPharmacistDirectPrescription: boolean;
}

export interface ReceptionSettings {
  /**
   * L'accueil peut émettre une proforma pour une consultation (généraliste / clinique).
   * Désactivé par défaut.
   */
  allowReceptionConsultationProforma: boolean;
  /** Tarif consultation généraliste pour la proforma (devise établissement). */
  generalConsultationFee: number;
}

/** Tarifs par défaut — revenus hospitaliers (Sprint H8). */
export interface HospitalRevenueSettings {
  emergencyVisitFee: number;
  hospitalizationDailyFee: number;
  nursingCareFee: number;
  surgeryProcedureFee: number;
  ambulanceTransportFee: number;
}

export interface MedicalUnit {
  id: string;
  code: string;
  name: string;
  active: boolean;
  /** Soft bind to EstablishmentSite (ADMIN3). */
  siteId?: string | null;
  /** Boxes / salles de consultation (ex. Box 1). */
  boxes?: string[];
}

export interface MedicalUnitInput {
  code: string;
  name: string;
  active?: boolean;
  siteId?: string | null;
  boxes?: string[];
}

export interface EstablishmentSite {
  id: string;
  code: string;
  name: string;
  active: boolean;
}

export interface EstablishmentSiteInput {
  code: string;
  name: string;
  active?: boolean;
}

export const DEFAULT_ESTABLISHMENT: EstablishmentProfile = {
  name: "",
  address: "",
  phone: "",
  email: "",
};

export const DEFAULT_PHARMACY_SETTINGS: PharmacySettings = {
  currency: "USD",
  invoicePrefix: "FAC",
  requirePatientOnInvoice: true,
  requirePharmacistValidation: true,
  syncBillingOnInvoice: true,
  allowPharmacistDirectPrescription: false,
};

export const DEFAULT_RECEPTION_SETTINGS: ReceptionSettings = {
  allowReceptionConsultationProforma: false,
  generalConsultationFee: 15,
};

export const DEFAULT_HOSPITAL_REVENUE_SETTINGS: HospitalRevenueSettings = {
  emergencyVisitFee: 35,
  hospitalizationDailyFee: 85,
  nursingCareFee: 12,
  surgeryProcedureFee: 450,
  ambulanceTransportFee: 60,
};

export interface RoleMenuMappingRow {
  permissionKey: string;
  label: string;
  menuSections: string[];
}
